import React from "react";
import { Eye, Users, TrendingUp, DollarSign } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const cards = [
  { icon: Eye, title: "More Visibility", testId: LANDING.goalCardVisibility, accent: "#00B2A9" },
  { icon: Users, title: "More Customers", testId: LANDING.goalCardCustomers, accent: "#EF426F" },
  { icon: TrendingUp, title: "More Sales", testId: LANDING.goalCardSales, accent: "#FF8200" },
  { icon: DollarSign, title: "More Revenue", testId: LANDING.goalCardRevenue, accent: "#0A0A0A" },
];

const Goal = () => {
  return (
    <section
      data-testid={LANDING.goalSection}
      className="py-20 md:py-28 px-6 md:px-12 bg-[#FAFAFA] border-y border-black/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#EF426F] mb-3">
              The Goal
            </p>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight max-w-2xl leading-[1.05]">
              If more customers would be a win for your business,
              <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text"> you're in the right place.</span>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map(({ icon: Icon, title, testId, accent }) => (
            <div
              key={title}
              data-testid={testId}
              className="group bg-white rounded-3xl border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)]"
            >
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center mb-6"
                style={{ backgroundColor: `${accent}1A`, color: accent }}
              >
                <Icon size={22} strokeWidth={2.4} />
              </div>
              <h3 className="text-xl md:text-2xl font-bold tracking-tight">{title}</h3>
              <p className="mt-2 text-sm md:text-base text-zinc-500 leading-relaxed">
                Built into every Spurs Finals Cash-In Package.
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Goal;
